import { useState } from 'react';

import { ChatComposer } from '@/modules/hiring-manager/chat/chatComposer/ChatComposer';
import { ChatExamples } from '@/modules/hiring-manager/chat/chatExamples/ChatExamples';
import { useNewChat } from '@/modules/hiring-manager/chat/useNewChat';

interface HomeChatProps {
  /** The HM's newest active job, which an example asks about. */
  recentJobTitle?: string;
}

/** The chat box on the portal home. A first message opens the chat on its own page at once. */
export function HomeChat({ recentJobTitle }: HomeChatProps) {
  const openNewChat = useNewChat();
  const [example, setExample] = useState({ key: 0, prompt: '' });

  return (
    <section aria-label="Chat with Finlay" className="flex flex-col gap-3">
      <ChatComposer
        busy={false}
        defaultValue={example.prompt}
        key={example.key}
        onSend={(text) => openNewChat(text)}
        placeholder="Describe a job, or ask Finlay"
      />
      <ChatExamples
        onPick={(prompt) =>
          setExample((current) => ({ key: current.key + 1, prompt }))
        }
        recentJobTitle={recentJobTitle}
      />
    </section>
  );
}
